import { SORT_BY } from "../actions/sort";
import {
  sortByKey,
  roleNames,
  dateHeadings,
  getDateHeading
} from "./presentation";

export const validUser = user => !!(user && user.email && user.id);

const categorizeUsersByRole = users => {
  const result = roleNames().map(n => ({ heading: `${n.nice}s`, users: [] }));
  users.forEach(u => {
    result[u.role].users.push(u);
  });

  result.forEach(r => {
    r.users = sortByKey(r.users, "email", true, true);
  });

  return result;
};

const categorizeUsersByDate = users => {
  const result = dateHeadings().map(h => ({ heading: h.nice, users: [] }));

  const userArraysByHeading = {};
  result.forEach(o => {
    userArraysByHeading[o.heading] = o.users;
  });

  users.forEach(u => {
    const heading = getDateHeading(u.createdOn);
    userArraysByHeading[heading].push(u);
  });

  result.forEach(r => {
    r.users = sortByKey(r.users, "createdOn", false, false);
  });

  return result;
};

const usersForAccount = (users, accountId) => {
  return Object.keys(users)
    .filter(k => users[k].account.toString() === accountId.toString())
    .map(k => users[k]);
};

export const prepareUsers = (users, accountId, sortOrder) => {
  const result = usersForAccount(users, accountId);
  if (sortOrder === SORT_BY.ROLE) {
    return categorizeUsersByRole(result);
  }
  return categorizeUsersByDate(result);
};



// WEBPACK FOOTER //
// ./src/helpers/users.js